import { render, staticRenderFns } from "./SnackbarSms.vue?vue&type=template&id=12faa237&scoped=true"
import script from "./SnackbarSms.vue?vue&type=script&lang=js"
export * from "./SnackbarSms.vue?vue&type=script&lang=js"
import style0 from "./SnackbarSms.vue?vue&type=style&index=0&id=12faa237&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12faa237",
  null
  
)

export default component.exports